import { render, staticRenderFns } from "./ExpedienteExtrato.vue?vue&type=template&id=4d52946e&"
import script from "./ExpedienteExtrato.vue?vue&type=script&lang=js&"
export * from "./ExpedienteExtrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports